export default __webpack_public_path__ + "static/media/AreaFun.39415a0b.svg";